import { render, staticRenderFns } from "./SkinToneEditor.vue?vue&type=template&id=02dfecc4&"
import script from "./SkinToneEditor.vue?vue&type=script&lang=ts&"
export * from "./SkinToneEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports